import React, { useState, useEffect, useContext, useLayoutEffect, useMemo } from 'react';
import { format } from 'date-fns';
import { dollarFormat } from 'utils/utils';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';

const PaymentPlanTable = ({ billingSummary, paymentPlanCreateInvoice, setSelectedPaymentPlan, getCaseDetails }) => {
  return (
    <>
      <GlobalLoader />
      <div className="d-flex py-2 flex-wrap time-entries">
        <div className="col-12 col-md-12 input-shadow p-2 mb-4">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Date</th>
                <th>Fee</th>
                <th>{''}</th>
              </tr>
            </thead>
            {billingSummary?.billing_info?.payment_plan_details?.payment_dates?.map((payment, index) => {
              return (
                <tbody>
                  <tr>
                    <td>{payment?.date ? format(new Date(payment?.date), 'MM/dd/yyyy') : ''}</td>
                    <td>{dollarFormat(payment?.amount)}</td>
                    <td>
                      {payment?.is_invoice_created ? (
                        <span style={{ margin: '7px' }}>Invoice Created</span>
                      ) : (
                        <span
                          className={'ms-2 redirection-link'}
                          role="button"
                          onClick={() => {
                            paymentPlanCreateInvoice();
                            setSelectedPaymentPlan({ ...payment, index });
                          }}
                          style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          Create Invoice
                        </span>
                      )}
                    </td>
                  </tr>
                </tbody>
              );
            })}
          </table>
        </div>
      </div>
    </>
  );
};

export default PaymentPlanTable;
